module.exports = __webpack_public_path__ + "img/top_separate.ec7568d0.svg";